import React, {
  useState
} from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import defaultTheme from '../config/theme';

const themeContext = React.createContext ();

const useTheme = (fingerprint) => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const [ darkMode, setDarkMode ] = useState(prefersDarkMode || localStorage.darkMode === 'true')

  const toggleDarkMode = () => {
    setDarkMode (!darkMode)
    localStorage.darkMode = !darkMode;
  }

  const theme = createMuiTheme({
    ...defaultTheme,
    palette: {
      ...defaultTheme.palette,
      type: darkMode ? 'dark' : 'light',
    },
  });

  return [ theme, toggleDarkMode];
}

const MyThemeProvider = (props) => {
  const {children} = props;
  const [ theme, toggleDarkMode ] = useTheme ();

  return <themeContext.Provider value={{theme, toggleDarkMode}}>
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  </themeContext.Provider>
}

export { MyThemeProvider as ThemeProvider, themeContext }